import * as Url from '../../config/Url'
import { authHeader } from '../../utils/AuthHeader';
import { handleResponse } from '../../utils/HandleResponse'

export const authService = {
    logIn,
    logOut,
    signUp,
    checkUser,
    getUserInfo,
    getReleaseDetail
};

function checkUser(address) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(Url.CHECK_USER + address, requestOptions).then(handleResponse);
}

async function signUp(payload, type) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };
    let url = Url[`${type}_SIGN_UP`]

    return fetch(url, requestOptions).then(handleResponse);

}

function logIn(payload, type) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };
    let url = Url[`${type}_LOGIN`];
    console.log('here is login url: ', type, url)
    return fetch(url, requestOptions).then(handleResponse);
}

function logOut() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getUserInfo(token) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(token),
    };

    return fetch(Url.GET_USERINFO, requestOptions).then(handleResponse);
}

function getReleaseDetail() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(Url.GET_RELEASE_DETAIL, requestOptions).then(handleResponse);
}



